export const ENTER_COMMAND = 'ENTER_COMMAND';
export const ALL_COMMAND = 'ALL_COMMAND';
export const CLEAR_COMMAND = 'CLEAR_COMMAND';